import request from '@/utils/request'
// 新增表单: post sheet/create，参数：
// title // 标题，必填
// text // 说明，选填
// questionList // 问题列表，必填
// /*[{
//  title // 标题,
//  typehood // 类型，1:单选，2:多选，3:数字，4:手机号，5:身份证号，6:单行文本，7:多行文本，
//  flag // 1:必填，2:选填，
//  options // [], 选项列表
// }]*/
// order // 顺序，选填
export function sheetCreate(data) {
    return request({
      url: '/sheet/create',
      method: 'post',
      data,
    })
  }

//   修改表单: post sheet/update，参数：
//   sheetId // 表单ID
//   title // 标题，选填
//   text // 说明，选填
//   questionList// 问题列表，选填
//   /*[{
//    title // 标题,
//    typehood // 类型，1:单选，2:多选，3:数字，4:手机号，5:身份证号，6:邮箱，7:单行文本，8:多行文本，
//    flag // 1:必填，2:选填，
//    options // [], 选项列表
//   }]*/
//   order // 顺序，选填
export function sheetUpdate(data) {
    return request({
        url: '/sheet/update',
        method: 'post',
        data,
    })
}
//获取问卷表列表
//获取表单列表: get sheet/findList，参数：
// page
// size
// title // 标题，选填
//获取插件
export function sheetFindList(params) {
    return request({
        url: '/sheet/findList',
        method: 'get',
        params,
    })
}
// 删除表单: post sheet/remove，参数：
// sheetId // 表单ID
export function sheetRemove(data) {
    return request({
        url: '/sheet/remove',
        method: 'post',
        data,
    })
}
// 获取单个表单: get sheet/find，参数：
// sheetId // 表单ID
export function sheetFind(params) {
    return request({
        url: '/sheet/find',
        method: 'get',
        params,
    })
}
// 获取表单记录列表 get sheet/findRecordList，参数：
// page
// size
// sheetId // 表单ID
export function findRecordList(params) {
    return request({
        url: '/sheet/findRecordList',
        method: 'get',
        params,
    })
}
//导出报表导出表单填写记录：get sheet/exportRecord，参数：
// sheetId // 表单ID
export function exportRecord(params) {
    return request({
        url: '/sheet/exportRecord',
        method: 'get',
        params,
    })
}
// 删除问卷记录：post sheet/removeRecord，参数：
// sheetRecordId // 记录ID
export function removeRecord(data) {
    return request({
        url: '/sheet/removeRecord',
        method: 'post',
        data,
    })
}

// 修改问卷记录：post sheet/updateRecord,参数：
// sheetRecordId // 记录ID
// answerList // 回答
export function updateRecord(data) {
    return request({
        url: '/sheet/updateRecord',
        method: 'post',
        data,
    })
}